import React, { Component, Fragment } from 'react'

export default class NotFound extends Component {
    render() {
        return (
            <Fragment>
                <header id="header">
                    <div className="container">
                        <div id="main-logo">
                            <a href='/'>
                                Centre Médical
                            <br/>
                                Bonnevoie
                            </a>
                        </div>
                    </div>
                </header>
                <header id="sub-header">
                    <div className="container">
                        <p className="schedule">
                           Error 404 - Page not found
                        </p>
                        
                    </div>
                </header>
                
                <main id="main">
                    <div id="ghost_banner"></div>
                    <div className="content">
                        <h1>Error 404 - Page not found</h1>
                        <a href='/' className='form__link--bottom'>Back to home page</a>
                        </div>
                        </main>
                        </Fragment>
        )
    }
}
